import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfigService } from './app.config.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ICheckoutEmail } from '../_models/email/checkout';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  private readonly http = inject(HttpClient);
  private readonly appConfig = inject(AppConfigService);
  private readonly snackBar = inject(MatSnackBar);

  private readonly headers = new HttpHeaders({'Content-Type': 'application/json'});
  private readonly options = { headers: this.headers };

  public signUpForNewsletter(email: string, webpage: string, token: string) {
    const body = {
      email,
      webpage,
      token
    };

    return this.http.post<any>(`${this.appConfig.config?.notificationApiUrl}/newsletter-signup`, body, { headers: this.headers });
  }

  public sendInquiryEmail(message: string, email: string, webpage: string, token: string) {
    const body = {
      email,
      message,
      webpage,
      token
    };

    return this.http.post<any>(`${this.appConfig.config?.notificationApiUrl}/send-inquiry-email`, body, { headers: this.headers });
  }

  public sendCheckoutEmail(email: ICheckoutEmail) {
    const body = {
      email: email.email,
      phone: email.phone,
      country: email.country,
      message: email.message,
      webpage: email.webpage,
      origin: email.origin
    };

    return this.http.post<any>(`${this.appConfig.config?.notificationApiUrl}/send-checkout-email`, body, { headers: this.headers });
  }

  public success(message: string): void {
    this.snackBar.open(message, 'Dismiss', {duration: 3000, panelClass: ['snackbar-info']});
  }

  public error(message: string): void {
    this.snackBar.open(message, 'Dismiss', {duration: 3000, panelClass: ['snackbar-info']});
  }
}
